// NPM Imports
import React, { Fragment } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Toastr } from "../../revvComponents";

// Components Imports

// Actions Imports
import { IntegrationsActions } from "../../actions";

// Local Imports
import { GlobalUtils } from "../../utils";
import { isBoxEsignFlowEnabled } from "../../actions/IntegrationsActions/IntegrationsMethods";

// Destructuring
const { getCRMInitData, authenticateCRM, getCrmAllUsers } = IntegrationsActions;
const { handleApiErrMsg, readDataFromLocalStorage } = GlobalUtils;

class BoxConnectionInfoBand extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      isDataLoaded: false,
    };
  }

  async componentDidMount() {
    // Check if box esign flag is enabled in org settings
    const isBoxEsignEnabled = await isBoxEsignFlowEnabled();
    // Check if box esign flag is enabled in org settings
    if (isBoxEsignEnabled) {
      this.props.getCRMInitData();
      this.props
        .getCrmAllUsers("BOX")
        .then(() => this.setState({ isDataLoaded: true }))
        .catch();
    }
  }

  _toggleLoader = flag => {
    this.setState({ showLoader: flag });
  };

  _connectToBoxAccount = () => {
    this._toggleLoader(true);
    const { clientId, clientSecret, redirectUrl, instanceUrl } =
      this.props.boxConfig;
    const config = {
      crm: "BOX",
      instance_url: instanceUrl.trim(),
      redirect_url: redirectUrl.trim(),
      client_id: clientId.trim(),
      client_secret: clientSecret.trim(),
      oauth_type: "user",
    };
    this._toggleLoader(true);
    this.props
      .authenticateCRM(config, window.location.pathname)
      .then(() => {
        this._toggleLoader(false);
      })
      .catch(error => {
        this._toggleLoader(false);
        Toastr.showToastr({
          type: "failure",
          message: handleApiErrMsg(error),
          timeout: 3000,
        });
      });
  };

  _decideView = () => {
    if (this.props.hasSignerTagsAdded) {
      if (!this.props.boxConfig.isCRMAuthenticated) {
        return (
          <div className="boxconnectioninfoband-wrapper">
            Reach out to your account admin to integrate with Box to proceed for
            eSignature.
            <span className="boxconnectioninfoband-close">
              <FontAwesomeIcon
                onClick={() => this.setState({ isDataLoaded: false })}
                onKeyDown={() => {}}
                role="button"
                tabIndex="0"
                icon={["far", "times"]}
                className=""
              />
            </span>
          </div>
        );
      }

      if (
        this.props.boxConfig.isCRMAuthenticated &&
        !this.props.isUserLoggedIntoBoxAcnt
      ) {
        return (
          <div className="boxconnectioninfoband-wrapper">
            {" "}
            <span>
              You are not connected to Box. Connect your account to be able to
              send documents for eSignature.{" "}
            </span>{" "}
            &nbsp;
            <span
              className="boxconnectioninfoband-connect"
              onKeyPress={() => {}}
              role="button"
              tabIndex="0"
              onClick={this._connectToBoxAccount}>
              Connect
            </span>
            &nbsp;&nbsp;&nbsp;&nbsp;
            {this.state.showLoader && (
              <FontAwesomeIcon icon={["fas", "spinner"]} className="fa-spin" />
            )}
            <span className="boxconnectioninfoband-close">
              <FontAwesomeIcon
                onClick={() => this.setState({ isDataLoaded: false })}
                onKeyDown={() => {}}
                role="button"
                tabIndex="0"
                icon={["far", "times"]}
                className=""
              />
            </span>
          </div>
        );
      }
    }
    return null;
  };

  render() {
    if (!this.state.isDataLoaded) {
      return <Fragment />;
    }
    return this._decideView();
  }
}

const mapStateToProps = state => {
  const {
    document: { signatoriesV2 },
  } = state.DocumentStore;
  const { crmConfig, crmAllUsers } = state.SettingsStore;

  // Data Mutation For Box Data
  const CURRENT_USER = readDataFromLocalStorage("revvsalesUser");
  const loggedInCrmUser =
    crmAllUsers.find(i => i.user_id === CURRENT_USER.id) || {};
  const boxCrmConfig =
    crmConfig &&
    crmConfig.crm &&
    Array.isArray(crmConfig.crm) &&
    crmConfig.crm.find(item => item.crm === "BOX");

  let boxConfig = {};
  if (boxCrmConfig && Object.keys(boxCrmConfig).length > 0) {
    boxConfig = {
      isCRMAuthenticated: boxCrmConfig.is_authenticated,
      clientId: boxCrmConfig.client_id,
      clientSecret: boxCrmConfig.client_secret,
      instanceUrl: boxCrmConfig.instance_url,
      redirectUrl: boxCrmConfig.redirect_url,
    };
  }

  return {
    hasSignerTagsAdded: signatoriesV2.length > 0,
    boxConfig,
    isUserLoggedIntoBoxAcnt: Object.keys(loggedInCrmUser).length > 0,
  };
};

const mapDispatchToProps = {
  authenticateCRM,
  getCRMInitData,
  getCrmAllUsers,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BoxConnectionInfoBand);
